"use client";

import { useResponsive } from "@dafiti/closet-ui/hooks";
import { useEffect, useRef } from "react";

import { useCatalogSettings } from "./useCatalogSettings.hook";
import { useInfiniteCatalogResults } from "./useInfiniteCatalogResults.hook";
import { usePaginatedCatalogResults } from "./usePaginatedCatalogResults.hook";

type Props = {
  userAgent?: string | null;
};

export function useCatalogResults({ userAgent }: Props = {}) {
  const { isMobile } = useResponsive({ userAgent });
  const isMobileResolved = isMobile ?? false;

  const [, setSettings] = useCatalogSettings();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setSettings({ page: 1 });
  }, [isMobileResolved, setSettings]);

  const paginated = usePaginatedCatalogResults({ enabled: !isMobileResolved });
  const infinite = useInfiniteCatalogResults({ enabled: isMobileResolved });

  return isMobileResolved ? infinite : paginated;
}
